
import React, { useState } from 'react';

import { amountFormatUse, getToken, local_utc_timestamp, utc_local, convertDecimalToTime } from '../../../helpers/Helper';
import { GET_EMPLOYEES_LIST, POST_ATTENDANCE_LIST, POST_DELETE_ATTENDANCE } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import EditAttendance from '../../../components/EditAttendance';
import { Link, useNavigate } from 'react-router-dom';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import { useTranslation } from 'react-i18next';
import { del, get } from '../../../helpers/api_helper';
import { toast } from 'react-toastify';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

const AttendanceList = (props) => {
    const { t } = useTranslation();
    const [id, SetId] = useState(0);
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [attendanceInfo, setAttendanceInfo] = useState(null);

    const [filter_option, setFilterOption] = useState({ 
        startDate: local_utc_timestamp(new Date()), 
        endDate: local_utc_timestamp(new Date()),
        employeeId : '',
    });


    useMounted(() => {
        getList();
        get_employees();
    })

    const get_employees = async () => {
        var api_res = await get(GET_EMPLOYEES_LIST);
        if (api_res.status) {
            setEmployees(api_res.data.employees.map(employee => ({
                value: employee.employeeId,
                label: `${employee.name} (E-${employee.employeeId})`
              })));
        } else {
            toast.error(api_res.message);
        }
    }

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[4, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [6, 7, 8] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.startDate = filter_option.startDate;
                    data.endDate = filter_option.endDate;
                    data.employeeId = filter_option.employeeId;

                    $.ajax({
                        "url": POST_ATTENDANCE_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "id" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>E-{data.employeeId}</>)
                        }
                    },
                    { "data": "name" },
                    { "data": "departmentName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.date, 'ddd, DD/MM/YYYY')}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.attendanceType === 'Present' && <span className='border-0 badge bg-success'>{data.attendanceType} {(data.overTimeHours > 0)? ` - (${convertDecimalToTime(data.overTimeHours)}h)` : ''}</span>}
                                {data.attendanceType === 'Full Day' && <span className='border-0 badge bg-success'>{data.attendanceType} {(data.overTimeHours > 0)? ` - (${convertDecimalToTime(data.overTimeHours)}h)` : ''}</span>}
                                {data.attendanceType === 'Half Day' && <span className='border-0 badge bg-info'>{data.attendanceType} {(data.overTimeHours > 0)? ` - (${convertDecimalToTime(data.overTimeHours)}h)` : ''}</span>}
                                {data.attendanceType === 'Over Time' && <span className='border-0 badge bg-warning'>{data.attendanceType} {(data.overTimeHours > 0)? ` - (${convertDecimalToTime(data.overTimeHours)}h)` : ''}</span>}
                                {data.attendanceType === 'Absent' && <span className='border-0 badge bg-danger'>{data.attendanceType} {(data.overTimeHours > 0)? ` - (${convertDecimalToTime(data.overTimeHours)}h)` : ''}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{convertDecimalToTime(data.totalHours)} Hours</>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{amountFormatUse(data.totalAmount)}</>)
                        }
                    },
                    {"data" : "source"},
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.source === 'Manual' && <button className="btn btn-sm text-primary mr-2" onClick={()=>{setAttendanceInfo(data)}} data-bs-toggle="modal" data-bs-target="#editModal"><i className="bx bx-edit"></i></button>}
                                <button className="btn btn-sm text-danger" onClick={() => { SetId(data.id); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>
                            </>)
                        }
                    },

                ]
            });
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(`${POST_DELETE_ATTENDANCE}?id=${id}&offset=${-new Date().getTimezoneOffset()}`);
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        filter_option[event.target.name] = event.target.value;
        setFilterOption({ ...filter_option });
    }

    const clear = () => {
        filter_option.startDate = local_utc_timestamp(new Date());
        filter_option.endDate = local_utc_timestamp(new Date());
        setFilterOption({ ...filter_option });
        getList();
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-8'>
                                    <h5 className='mt-1'>{t('attendance.list.title')} </h5>
                                </div>
                                <div className='col-4 text-right'>
                                    <Link to='/attendance/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link>
                                </div>
                            </div>
                            <hr />

                            <div className='row mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Start Date</label>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.startDate} onChange={(date) => {
                                            handleInputChangeFilter({ target: { name: 'startDate', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>End Date</label>
                                    <DatePicker name='endDate' className='form-control'
                                        selected={filter_option.endDate} onChange={(date) => {
                                            handleInputChangeFilter({ target: { name: 'endDate', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Employees</label>
                                    <Select
                                        name='employeeId'
                                        value={employees.find(emp => emp.value === filter_option.employeeId) || null}
                                        onChange={(value) => {handleInputChangeFilter({target : {name : 'employeeId', value : value.value}})}}
                                        options={employees}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3 pt-4'>
                                    <button type='button' onClick={getList} className='btn btn-primary me-3'>Apply</button>
                                    <button type='button' onClick={clear} className='btn btn-danger'>Clear</button>
                                </div>
                            </div>
                            <hr />

                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>{t('attendance.list.employeeId')}</td>
                                            <td>{t('attendance.list.name')}</td>
                                            <td>{t('attendance.list.departmentName')}</td>
                                            <td>{t('attendance.list.date')}</td>
                                            <td>{t('attendance.list.type')}</td>
                                            <td>{t('attendance.list.totalHours')}</td>
                                            <td>{t('attendance.list.amount')}</td>
                                            <td>{t('attendance.list.source')}</td>
                                            <td>{t('attendance.list.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('delete.title')}</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{t('delete.message')}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('delete.no')}</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">{t('delete.yes')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <EditAttendance attendanceInfo={attendanceInfo} call_back={() => {getList()}} />
        </>
    );
}

export default AttendanceList;